import Deals from './Deals.page';

export default Deals;